<template>
  <div class="orderBottom" id="orderBtn2">
    <button type="button" class="toggleBtn" @click="hideOrderLayer">주문옵션</button>
    <div class="topArea">
      <!-- tabWrap (s) -->
      <div class="tabWrap">
        <ul class="tabList iptBtn directPay" v-if="productDetail.saleDivCd == 'RTSL0003' && productDetail.instYn =='N'">
          <li class="on" @click="order_type = 'pay'"><span class="ico">구매</span></li>
        </ul>
        <ul class="tabList iptBtn allPay" v-else>
          <li class="on" @click="order_type = 'rental'"><span class="ico">렌탈</span></li>
          <li @click="order_type = 'pay'"><span class="ico">구매</span></li>
        </ul>
        <div class="tabContents">
          <div class="tabPanel" v-if="productDetail.saleDivCd == 'RTSL0003' && productDetail.instYn =='N'">
            <ul class="prdSlt">
              <template v-if="productOptions.productOption1">
                <li v-if="productOptions.productOption1.length > 0">
                  <div class="accoHead">
                    <div class="accoBtn">
                      <span class="inner">
                        <span class="item">옵션</span>
                        <span class="val placeholder">선택해주세요</span>
                      </span>
                    </div>
                  </div>
                  <div class="accoBody">
                    <ul class="iptGroup">
                      <li v-for="(productOption1, index) in productOptions.productOption1" :key="index">
                        <input
                          type="radio"
                          class="ipt"
                          v-model="order2_productOption1"
                          :id="'item6_' + (index + 1)"
                          :value="productOption1.optionCode"
                          @change="changed(productOption1.saleAmount, productOption1.internalProdCode)"
                        />
                        <label :for="'item6_' + (index + 1)">
                          <span>{{ productOption1.optionName }}</span>
                        </label>
                      </li>
                    </ul>
                  </div>
                </li>
              </template>
              <template v-if="productOptions.productOption2">
                <li v-if="productOptions.productOption2.length > 0">
                  <div class="accoHead">
                    <div class="accoBtn">
                      <span class="inner">
                        <span class="item">옵션</span>
                        <span class="val placeholder">선택해주세요</span>
                      </span>
                    </div>
                  </div>
                  <div class="accoBody">
                    <ul class="iptGroup">
                      <li v-for="(productOption2, index) in productOptions.productOption2" :key="index">
                        <input
                          type="radio"
                          class="ipt"
                          v-model="order2_productOption2"
                          :id="'item7_' + (index + 1)"
                          :value="productOption2.optionCode"
                        />
                        <label :for="'item7_' + (index + 1)">
                          <span>{{ productOption2.optionName }}</span>
                        </label>
                      </li>
                    </ul>
                  </div>
                </li>
              </template>
              <template v-if="productOptions.productOption3">
                <li v-if="productOptions.productOption3.length > 0">
                  <div class="accoHead">
                    <div class="accoBtn">
                      <span class="inner">
                        <span class="item">옵션</span>
                        <span class="val placeholder">선택해주세요</span>
                      </span>
                    </div>
                  </div>
                  <div class="accoBody">
                    <ul class="iptGroup">
                      <li v-for="(productOption3, index) in productOptions.productOption3" :key="index">
                        <input
                          type="radio"
                          class="ipt"
                          v-model="order2_productOption3"
                          :id="'item8_' + (index + 1)"
                          :value="productOption3.optionCode"
                        />
                        <label :for="'item8_' + (index + 1)">
                          <span>{{ productOption3.optionName }}</span>
                        </label>
                      </li>
                    </ul>
                  </div>
                </li>
              </template>
              <template v-if="productColors">
                <li v-if="productColors.length > 0">
                  <div class="accoHead">
                    <div class="accoBtn">
                      <span class="inner">
                        <span class="item">색상</span>
                        <span class="val placeholder">선택해주세요</span>
                      </span>
                    </div>
                  </div>
                  <div class="accoBody">
                    <ul class="iptGroup">
                      <li v-for="(productColor, index) in productColors" :key="index">
                        <input type="radio" class="ipt" v-model="order2_productColors" :id="'item9_' + (index + 1)" :value="productColor.colorCode" />
                        <label :for="'item9_' + (index + 1)">
                          <span>{{ productColor.colorCodeNm }}</span>
                        </label>
                      </li>
                    </ul>
                  </div>
                </li>
              </template>
              <template v-if="productOptions.checkType">
                <li v-if="productOptions.checkType.length > 0">
                  <div class="accoHead">
                    <div class="accoBtn">
                      <span class="inner">
                        <span class="item">점검</span>
                        <span class="val placeholder">선택해주세요</span>
                      </span>
                    </div>
                  </div>
                  <div class="accoBody">
                    <ul class="iptGroup">
                      <li v-for="(checkType, index) in productOptions.checkType" :key="index">
                        <input type="radio" class="ipt" v-model="order2_checkType" :id="'item13_' + (index + 1)" :value="checkType.optionCode" />
                        <label :for="'item13_' + (index + 1)">
                          <span>{{ checkType.optionName }}</span>
                        </label>
                      </li>
                    </ul>
                  </div>
                </li>
              </template>
              <template v-if="productOptions.instType">
                <li v-if="productOptions.instType.length > 0">
                  <div class="accoHead">
                    <div class="accoBtn">
                      <span class="inner">
                        <span class="item">유형</span>
                        <span class="val placeholder">선택해주세요</span>
                      </span>
                    </div>
                  </div>
                  <div class="accoBody">
                    <ul class="iptGroup">
                      <li v-for="(instType, index) in productOptions.instType" :key="index">
                        <input type="radio" class="ipt" v-model="order2_instType" :id="'item14_' + (index + 1)" :value="instType.optionCode" />
                        <label :for="'item14_' + (index + 1)">
                          <span>{{ instType.optionName }}</span>
                        </label>
                      </li>
                    </ul>
                  </div>
                </li>
              </template>
              <li>
                <div class="accoHead">
                  <div class="accoBtn">
                    <span class="inner">
                      <span class="item">할인쿠폰</span>
                      <span class="val placeholder">선택해주세요</span>
                    </span>
                  </div>
                </div>
                <div class="accoBody">
                  <ul class="iptGroup">
                    <li v-for="(orderCupon, index) in orderCuponListPurchase" :key="index">
                      <input type="radio" class="ipt" name="item21" v-model="order2_coupon" :id="'item121_' + (index + 1)" :value="index" />
                      <label :for="'item121_' + (index + 1)">
                        <span>{{ orderCupon.title }}</span>
                      </label>
                    </li>
                    <li v-if="orderCuponListPurchase.length == 0">
                      <input type="radio" class="ipt" name="item21" id="item21_100" value="" />
                      <label for="item21_100"><span>없음</span></label>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
          <div class="tabPanel">
            <ul class="prdSlt">
              <li>
                <div class="accoHead">
                  <div class="accoBtn">
                    <span class="inner">
                      <span class="item">렌탈기간</span>
                      <span class="val placeholder" id="rentalPeriod1" ref="rentalPeriod1">선택해주세요</span>
                    </span>
                  </div>
                </div>
                <div class="accoBody">
                  <ul class="iptGroup">
                    <li v-for="(rentalPeriod, index) in productOptions.rentalPeriod" :key="index">
                      <input type="radio" class="ipt" v-model="order_rentalPeriod" :id="'item0_' + (index + 1)" :value="rentalPeriod.optionCode" />
                      <label :for="'item0_' + (index + 1)">
                        <span>{{ rentalPeriod.optionName }}</span>
                      </label>
                    </li>
                  </ul>
                </div>
              </li>
              <template v-if="productOptions.productOption1">
                <li v-if="productOptions.productOption1.length > 0">
                  <div class="accoHead">
                    <div class="accoBtn">
                      <span class="inner">
                        <span class="item">옵션</span>
                        <span class="val placeholder">선택해주세요</span>
                      </span>
                    </div>
                  </div>
                  <div class="accoBody">
                    <ul class="iptGroup">
                      <li v-for="(productOption1, index) in productOptions.productOption1" :key="index">
                        <input
                          type="radio"
                          class="ipt"
                          v-model="order_productOption1"
                          :id="'item1_' + (index + 1)"
                          :value="productOption1.optionCode"
                        />
                        <label :for="'item1_' + (index + 1)">
                          <span>{{ productOption1.optionName }}</span>
                        </label>
                      </li>
                    </ul>
                  </div>
                </li>
              </template>
              <template v-if="productOptions.productOption2">
                <li v-if="productOptions.productOption2.length > 0">
                  <div class="accoHead">
                    <div class="accoBtn">
                      <span class="inner">
                        <span class="item">옵션</span>
                        <span class="val placeholder">선택해주세요</span>
                      </span>
                    </div>
                  </div>
                  <div class="accoBody">
                    <ul class="iptGroup">
                      <li v-for="(productOption2, index) in productOptions.productOption2" :key="index">
                        <input
                          type="radio"
                          class="ipt"
                          v-model="order_productOption2"
                          :id="'item2_' + (index + 1)"
                          :value="productOption2.optionCode"
                        />
                        <label :for="'item2_' + (index + 1)">
                          <span>{{ productOption2.optionName }}</span>
                        </label>
                      </li>
                    </ul>
                  </div>
                </li>
              </template>
              <template v-if="productOptions.productOption3">
                <li v-if="productOptions.productOption3.length > 0">
                  <div class="accoHead">
                    <div class="accoBtn">
                      <span class="inner">
                        <span class="item">옵션</span>
                        <span class="val placeholder">선택해주세요</span>
                      </span>
                    </div>
                  </div>
                  <div class="accoBody">
                    <ul class="iptGroup">
                      <li v-for="(productOption3, index) in productOptions.productOption3" :key="index">
                        <input
                          type="radio"
                          class="ipt"
                          v-model="order_productOption3"
                          :id="'item3_' + (index + 1)"
                          :value="productOption3.optionCode"
                        />
                        <label :for="'item3_' + (index + 1)">
                          <span>{{ productOption3.optionName }}</span>
                        </label>
                      </li>
                    </ul>
                  </div>
                </li>
              </template>
              <template v-if="productColors">
                <li v-if="productColors.length > 0">
                  <div class="accoHead">
                    <div class="accoBtn">
                      <span class="inner">
                        <span class="item">색상</span>
                        <span class="val placeholder">선택해주세요</span>
                      </span>
                    </div>
                  </div>
                  <div class="accoBody">
                    <ul class="iptGroup">
                      <li v-for="(productColor, index) in productColors" :key="index">
                        <input type="radio" class="ipt" v-model="order_productColors" :id="'item4_' + (index + 1)" :value="productColor.colorCode" />
                        <label :for="'item4_' + (index + 1)">
                          <span>{{ productColor.colorCodeNm }}</span>
                        </label>
                      </li>
                    </ul>
                  </div>
                </li>
              </template>
              <template v-if="productOptions.checkType">
                <li v-if="productOptions.checkType.length > 0">
                  <div class="accoHead">
                    <div class="accoBtn">
                      <span class="inner">
                        <span class="item">점검</span>
                        <span class="val placeholder">선택해주세요</span>
                      </span>
                    </div>
                  </div>
                  <div class="accoBody">
                    <ul class="iptGroup">
                      <li v-for="(checkType, index) in productOptions.checkType" :key="index">
                        <input type="radio" class="ipt" v-model="order_checkType" :id="'item11_' + (index + 1)" :value="checkType.optionCode" />
                        <label :for="'item11_' + (index + 1)">
                          <span>{{ checkType.optionName }}</span>
                        </label>
                      </li>
                    </ul>
                  </div>
                </li>
              </template>
              <template v-if="productOptions.instType">
                <li v-if="productOptions.instType.length > 0">
                  <div class="accoHead">
                    <div class="accoBtn">
                      <span class="inner">
                        <span class="item">유형</span>
                        <span class="val placeholder">선택해주세요</span>
                      </span>
                    </div>
                  </div>
                  <div class="accoBody">
                    <ul class="iptGroup">
                      <li v-for="(instType, index) in productOptions.instType" :key="index">
                        <input type="radio" class="ipt" v-model="order_instType" :id="'item12_' + (index + 1)" :value="instType.optionCode" />
                        <label :for="'item12_' + (index + 1)">
                          <span>{{ instType.optionName }}</span>
                        </label>
                      </li>
                    </ul>
                  </div>
                </li>
              </template>
              <li>
                <div class="accoHead">
                  <div class="accoBtn">
                    <span class="inner">
                      <span class="item">할인쿠폰</span>
                      <span class="val placeholder">선택해주세요</span>
                    </span>
                  </div>
                </div>
                <div class="accoBody">
                  <ul class="iptGroup">
                    <li v-for="(orderCupon, index) in orderCuponList" :key="index">
                      <input type="radio" class="ipt" name="item20" v-model="order_coupon" :id="'item120_' + (index + 1)" :value="index" />
                      <label :for="'item120_' + (index + 1)">
                        <span>{{ orderCupon.title }}</span>
                      </label>
                    </li>
                    <li v-if="orderCuponList.length == 0">
                      <input type="radio" class="ipt" name="item20" id="item20_100" value="" />
                      <label for="item20_100"><span>없음</span></label>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
            <p class="txtList_remark">제휴카드는 전월실적에 따라 청구 할인되어 예상금액은 실제 납부 금액과 다를 수 있습니다.</p>
          </div>
          <div class="tabPanel">
            <ul class="prdSlt">
              <template v-if="productOptions.productOption1">
                <li v-if="productOptions.productOption1.length > 0">
                  <div class="accoHead">
                    <div class="accoBtn">
                      <span class="inner">
                        <span class="item">옵션</span>
                        <span class="val placeholder">선택해주세요</span>
                      </span>
                    </div>
                  </div>
                  <div class="accoBody">
                    <ul class="iptGroup">
                      <li v-for="(productOption1, index) in productOptions.productOption1" :key="index">
                        <input
                          type="radio"
                          class="ipt"
                          v-model="order2_productOption1"
                          :id="'item6_' + (index + 1)"
                          :value="productOption1.optionCode"
                        />
                        <label :for="'item6_' + (index + 1)">
                          <span>{{ productOption1.optionName }}</span>
                        </label>
                      </li>
                    </ul>
                  </div>
                </li>
              </template>
              <template v-if="productOptions.productOption2">
                <li v-if="productOptions.productOption2.length > 0">
                  <div class="accoHead">
                    <div class="accoBtn">
                      <span class="inner">
                        <span class="item">옵션</span>
                        <span class="val placeholder">선택해주세요</span>
                      </span>
                    </div>
                  </div>
                  <div class="accoBody">
                    <ul class="iptGroup">
                      <li v-for="(productOption2, index) in productOptions.productOption2" :key="index">
                        <input
                          type="radio"
                          class="ipt"
                          v-model="order2_productOption2"
                          :id="'item7_' + (index + 1)"
                          :value="productOption2.optionCode"
                        />
                        <label :for="'item7_' + (index + 1)">
                          <span>{{ productOption2.optionName }}</span>
                        </label>
                      </li>
                    </ul>
                  </div>
                </li>
              </template>
              <template v-if="productOptions.productOption3">
                <li v-if="productOptions.productOption3.length > 0">
                  <div class="accoHead">
                    <div class="accoBtn">
                      <span class="inner">
                        <span class="item">옵션</span>
                        <span class="val placeholder">선택해주세요</span>
                      </span>
                    </div>
                  </div>
                  <div class="accoBody">
                    <ul class="iptGroup">
                      <li v-for="(productOption3, index) in productOptions.productOption3" :key="index">
                        <input
                          type="radio"
                          class="ipt"
                          v-model="order2_productOption3"
                          :id="'item8_' + (index + 1)"
                          :value="productOption3.optionCode"
                        />
                        <label :for="'item8_' + (index + 1)">
                          <span>{{ productOption3.optionName }}</span>
                        </label>
                      </li>
                    </ul>
                  </div>
                </li>
              </template>
              <template v-if="productColors">
                <li v-if="productColors.length > 0">
                  <div class="accoHead">
                    <div class="accoBtn">
                      <span class="inner">
                        <span class="item">색상</span>
                        <span class="val placeholder">선택해주세요</span>
                      </span>
                    </div>
                  </div>
                  <div class="accoBody">
                    <ul class="iptGroup">
                      <li v-for="(productColor, index) in productColors" :key="index">
                        <input type="radio" class="ipt" v-model="order2_productColors" :id="'item9_' + (index + 1)" :value="productColor.colorCode" />
                        <label :for="'item9_' + (index + 1)">
                          <span>{{ productColor.colorCodeNm }}</span>
                        </label>
                      </li>
                    </ul>
                  </div>
                </li>
              </template>
              <template v-if="productOptions.checkType">
                <li v-if="productOptions.checkType.length > 0">
                  <div class="accoHead">
                    <div class="accoBtn">
                      <span class="inner">
                        <span class="item">점검</span>
                        <span class="val placeholder">선택해주세요</span>
                      </span>
                    </div>
                  </div>
                  <div class="accoBody">
                    <ul class="iptGroup">
                      <li v-for="(checkType, index) in productOptions.checkType" :key="index">
                        <input type="radio" class="ipt" v-model="order2_checkType" :id="'item13_' + (index + 1)" :value="checkType.optionCode" />
                        <label :for="'item13_' + (index + 1)">
                          <span>{{ checkType.optionName }}</span>
                        </label>
                      </li>
                    </ul>
                  </div>
                </li>
              </template>
              <template v-if="productOptions.instType">
                <li v-if="productOptions.instType.length > 0">
                  <div class="accoHead">
                    <div class="accoBtn">
                      <span class="inner">
                        <span class="item">유형</span>
                        <span class="val placeholder">선택해주세요</span>
                      </span>
                    </div>
                  </div>
                  <div class="accoBody">
                    <ul class="iptGroup">
                      <li v-for="(instType, index) in productOptions.instType" :key="index">
                        <input type="radio" class="ipt" v-model="order2_instType" :id="'item14_' + (index + 1)" :value="instType.optionCode" />
                        <label :for="'item14_' + (index + 1)">
                          <span>{{ instType.optionName }}</span>
                        </label>
                      </li>
                    </ul>
                  </div>
                </li>
              </template>
              <li>
                <div class="accoHead">
                  <div class="accoBtn">
                    <span class="inner">
                      <span class="item">할인쿠폰</span>
                      <span class="val placeholder">선택해주세요</span>
                    </span>
                  </div>
                </div>
                <div class="accoBody">
                  <ul class="iptGroup">
                    <li v-for="(orderCupon, index) in orderCuponListPurchase" :key="index">
                      <input type="radio" class="ipt" name="item21" v-model="order2_coupon" :id="'item121_' + (index + 1)" :value="index" />
                      <label :for="'item121_' + (index + 1)">
                        <span>{{ orderCupon.title }}</span>
                      </label>
                    </li>
                    <li v-if="orderCuponListPurchase.length == 0">
                      <input type="radio" class="ipt" name="item21" id="item21_100" value="" />
                      <label for="item21_100"><span>없음</span></label>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- tabWrap (e) -->
    </div>
    <div class="bottomArea">
      <div class="prdPrice">
        <div class="row" v-if="order_type == 'rental'">
          <span class="info">렌탈 금액</span>
          <div class="val">
            <span class="price pointC1">
              월
              <em class="money">{{ show_rentalAmount | currency }}</em>
              원×
              <span>{{ show_rentalPeriod }}</span>
              개월
            </span>
          </div>
        </div>
        <div class="row" v-if="order_type == 'pay'">
          <span class="info">구매 금액</span>
          <div class="val">
            <span class="price pointC1">
              <em class="money">{{ show_saleAmount | currency }}</em>
              원
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="btnArea two half sticky">
      <button type="button" class="btn_g" @click="goBasket">장바구니</button>
      <button type="button" class="btn_p" @click="goOrder">
        <template v-if="order_type == 'rental'">렌탈하기</template>
        <template v-else>구매하기</template>
      </button>
    </div>
    <MessagePop v-if="messagePop" @close="close">
      <p v-html="msg"></p>
    </MessagePop>
    <MessagePop v-if="messagePop2" @close="basketClose">
      <p v-html="msg"></p>
    </MessagePop>
  </div>
</template>

<script>
import $ from 'jquery';
import JwtService from '@/common/jwt.service';
import ApiService from '@/common/api.service';
import MessagePop from '@/components/popup/MessagePop';
import { INPUT_BASKET_COMPLETE, OPTION_SELECT } from '@/store/message.type.js';
import { isEmpty } from '@/common/common.function';
import { find } from 'lodash';

export default {
  name: 'ProductDetailPop',
  components: {
    MessagePop,
  },
  props: ['productCode', 'productDetail', 'productOptions', 'productColors', 'orderCuponList', 'orderCuponListPurchase', 'prodOptionCollect'],
  data() {
    return {
      userInfo: JwtService.getUserInfo(), // 로그인 사용자 정보
      order_type: 'rental',

      order_rentalPeriod: '0',
      order_productOption1: '',
      order_productOption2: '',
      order_productOption3: '',
      order_productColors: '',
      order_checkType: '',
      order_instType: '',
      order_coupon: '',

      show_rentalPeriod: '0',
      show_rentalAmount: '0',
      show_saleAmount: '0',

      order2_productOption1: '',
      order2_productOption2: '',
      order2_productOption3: '',
      order2_productColors: '',
      order2_checkType: '',
      order2_instType: '',
      order2_coupon: '',

      messagePop: null,
      messagePop2: null,
      msg: null,
      marParam: '' ,//마케팅정보
      goodsTpCd: '' //소모품 채번 위한 부품 타입 확인
    };
  },
  watch: {
    order_rentalPeriod() {
      this.show_rentalPeriod = this.$refs['rentalPeriod1'].textContent.replace('개월', '');
      this.getPrice();
    },
    order_productOption1() {
      this.getPrice();
      this.changed();
    },
    order_productOption2() {
      this.getPrice();
    },
    order_productOption3() {
      this.getPrice();
    },
    order_checkType() {
      this.getPrice();
    },
    order_instType() {
      this.getPrice();
    },

    order2_productOption1() {
      this.getPrice();
    },
    order2_productOption2() {
      this.getPrice();
    },
    order2_productOption3() {
      this.getPrice();
    },
    order2_checkType() {
      this.getPrice();
    },
    order2_instType() {
      this.getPrice();
    },
  },
  mounted() {
    this.show_saleAmount = this.productDetail.saleAmount;
    this.show_rentalAmount = this.productDetail.rentalAmount;
    this.goodsTpCd = this.productDetail.goodsTpCd;
    this.internalProdCode = this.productDetail.internalProdCode;
  },
  methods: {
    goOrder() {
      //const data = this.order_type == 'rental' ? this.$props.orderCuponList[this.order_coupon] : this.$props.orderCuponListPurchase[this.order2_coupon];
      const data = this.order_type == 'rental' ? this.$props.orderCuponList[this.order_coupon] : this.$props.orderCuponListPurchase[this.order2_coupon];
      //const data = this.$props.orderCuponListPurchase[this.order2_coupon];

      if (this.checkOption()) {
        this.msg = OPTION_SELECT;
        this.messagePop = true;
        return false;
      }

      const params = {
        af_content_id: this.productCode,
        af_content_saleAmount: this.show_saleAmount,
        af_content_type: this.order_type == 'rental' ? '렌탈' : '일시불',
      };

      window.appsFlyer('af_PDP_order', params);

      $('.plpDim').remove(); // 검은 부분 제거

      console.log('=====주문하기');

      if (this.order_type === 'rental') {
        // 렌탈
        console.log('렌탈기간 : ' + this.order_rentalPeriod);
        console.log('옵션1 : ' + this.order_productOption1);
        console.log('옵션2 : ' + this.order_productOption2);
        console.log('옵션3 : ' + this.order_productOption3);
        console.log('색상 : ' + this.order_productColors);
        console.log('점검 : ' + this.order_checkType);
        console.log('유형 : ' + this.order_instType);
        console.log('쿠폰 : ' + JSON.stringify(data));
        console.log(this.userInfo);

        if (this.userInfo !== '' && this.userInfo !== null) {
          this.$router.push({
            name: 'memberMain',
            params: {
              productCode: this.productCode,
              internalProdCode: this.getInternalProdCode(),
              colorCode: this.order_productColors,
              coupon: data ? data.couponId : '',
              couponSerialNumber: data ? data.couponSerialNumber : '',
            },
          });
        } else {
          this.$router.push({
            name: 'login',
            params: {
              nextPage: 'guestStep1',
              productCode: this.productCode,
              internalProdCode: this.getInternalProdCode(),
              colorCode: this.order_productColors,
              coupon: data ? data.couponId : '',
              couponSerialNumber: data ? data.couponSerialNumber : '',
            },
          });
        }
      } else if (this.order_type === 'pay') {
        // 구매
        console.log('옵션1 : ' + this.order2_productOption1);
        console.log('옵션2 : ' + this.order2_productOption2);
        console.log('옵션3 : ' + this.order2_productOption3);
        console.log('색상 : ' + this.order2_productColors);
        console.log('점검 : ' + this.order2_checkType);
        console.log('유형 : ' + this.order2_instType);
        console.log('쿠폰 : ' + JSON.stringify(data));
        console.log('타입 : ' + this.goodsTpCd);

        if (this.userInfo !== '' && this.userInfo !== null) {
          //this.$router.push('/order/payment/paymentMemberMain/' + this.productCode);
          this.$router.push({
            name: 'paymentMemberMain',
            params: {
              productCode: this.productCode,
              order2_productOption1: this.order2_productOption1,
              order2_productOption2: this.order2_productOption2,
              order2_productOption3: this.order2_productOption3,
              productColors: this.order2_productColors,
              order2_checkType: this.order2_checkType,
              order2_instType: this.order2_instType,
              coupon: data ? data.couponId : '',
              couponSerialNumber: data ? data.couponSerialNumber : '',
              marParam: this.marParam,
              goodsTpCd: this.goodsTpCd,
              saleAmount: this.show_saleAmount,
              internalProdCode: this.internalProdCode,
            },
          });
        } else {
          //this.$router.push('/order/payment/paymentGuestMain/' + this.productCode);

          this.$router.push({
            name: 'login',
            params: {
              nextPage: 'paymentGuestMain',
              productCode: this.productCode,
              order2_productOption1: this.order2_productOption1,
              order2_productOption2: this.order2_productOption2,
              order2_productOption3: this.order2_productOption3,
              productColors: this.order2_productColors,
              order2_checkType: this.order2_checkType,
              order2_instType: this.order2_instType,
              coupon: data ? data.couponId : '',
              couponSerialNumber: data ? data.couponSerialNumber : '',
              marParam: this.marParam,
              goodsTpCd: this.goodsTpCd,
              saleAmount: this.show_saleAmount,
              internalProdCode: this.internalProdCode,
            },
          });
        }
      }
    },
    hideOrderLayer() {
      $('.plpDim').fadeOut();
      $('#orderBtn1').show();
      $('#orderBtn2').hide();
      $('body').removeClass('popOn');
      $('.wrapper').removeAttr('aria-hidden tabindex');
    },
    goBasket() {
      //로그인 체크
      console.log(this.userInfo);

      if (this.userInfo == '' || this.userInfo == null) {
        this.$emit('redirectLoginConfirm');
        return false;
      }

      let param = new Object();
      let request = new Object();

      // 옵션 수정
      if (this.checkOption()) {
        this.msg = OPTION_SELECT;
        this.messagePop = true;
        return false;
      }

      let optionProdCode = this.getInternalProdCode();
      let productColors = '';

      if (this.order_type == 'rental') {
        productColors = this.order_productColors;
      } else if (this.order_type == 'pay') {
        productColors = this.order2_productColors;
      }

      request.internalProdCode = optionProdCode;
      request.colorCode = productColors;

      if (this.order_type === 'rental') {
        request.basketCd = 'BSKT0001';
      } else if (this.order_type == 'pay') {
        request.basketCd = 'BSKT0002';
      }

      param.request = request;
      param.serviceType = 'app';

      ApiService.service('POST', '/user/auth/basket', param)
        .then(({ data }) => {
          if (data.isSucceed) {
            const header = this.$parent.$children.find((child) => {
              return child.$options.name === 'Header';
            });
            header.getBasketCount();

            const params = {
              af_price: this.order_type === 'rental' ? this.show_rentalAmount : this.show_saleAmount,
              af_content_type: this.order_type === 'rental' ? '렌탈' : '일시불',
              af_content_id: this.productCode,
              af_content: this.show_rentalPeriod,
              // af_currency: 'af_currency',
              // af_quantity: 'af_quantity',
            };

            //const appsFlyerParams = JSON.stringify(params);
            window.appsFlyer('af_add_to_cart', params);

            this.msg = INPUT_BASKET_COMPLETE;
            this.messagePop2 = true;
          } else {
            this.msg = data.error;
            this.messagePop2 = true;
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    close() {
      this.messagePop = false;
    },
    checkOption() {
      let inputFlag = false;
      if (this.order_type == 'rental') {
        if (this.productOptions.rentalPeriod.length > 0 && this.order_rentalPeriod == '0') {
          inputFlag = true;
        }

        if (this.productOptions.checkType.length > 0 && isEmpty(this.order_checkType)) {
          inputFlag = true;
        }

        if (this.productOptions.instType.length > 0 && isEmpty(this.order_instType)) {
          inputFlag = true;
        }

        if (this.productOptions.productOption1.length > 0 && isEmpty(this.order_productOption1)) {
          inputFlag = true;
        }

        if (this.productOptions.productOption2.length > 0 && isEmpty(this.order_productOption2)) {
          inputFlag = true;
        }

        if (this.productOptions.productOption3.length > 0 && isEmpty(this.order_productOption3)) {
          inputFlag = true;
        }

        if (this.productColors.length > 0 && isEmpty(this.order_productColors)) {
          inputFlag = true;
        }
      } else if (this.order_type == 'pay') {
        if (this.productOptions.checkType.length > 0 && isEmpty(this.order2_checkType)) {
          inputFlag = true;
        }

        if (this.productOptions.instType.length > 0 && isEmpty(this.order2_instType)) {
          inputFlag = true;
        }

        if (this.productOptions.productOption1.length > 0 && isEmpty(this.order2_productOption1)) {
          inputFlag = true;
        }

        if (this.productOptions.productOption2.length > 0 && isEmpty(this.order2_productOption2)) {
          inputFlag = true;
        }

        if (this.productOptions.productOption3.length > 0 && isEmpty(this.order2_productOption3)) {
          inputFlag = true;
        }

        if (this.productColors.length > 0 && isEmpty(this.order2_productColors)) {
          inputFlag = true;
        }
      }
      return inputFlag;
    },
    getInternalProdCode() {
      let optionProdCode = '';

      if (this.productOptions.productOption1.length == 0) {
        this.order_productOption1 = 'FM060001';
        this.order2_productOption1 = 'FM060001';
      }
      if (this.productOptions.productOption2.length == 0) {
        this.order_productOption2 = 'FM060001';
        this.order2_productOption2 = 'FM060001';
      }
      if (this.productOptions.productOption3.length == 0) {
        this.order_productOption3 = 'FM060001';
        this.order2_productOption3 = 'FM060001';
      }
      if (this.productOptions.instType.length == 0) {
        this.order_instType = 'RNOR0001';
        this.order2_instType = 'RNOR0001';
      }
      if (this.productOptions.checkType.length == 0) {
        this.order_checkType = 'RREG0001';
        this.order2_checkType = 'RREG0001';
      }
      if (this.order_type == 'rental') {
        for (let optionCollect of this.prodOptionCollect) {
          if (
            this.order_rentalPeriod == optionCollect.rentalPeriod &&
            this.order_productOption1 == optionCollect.optionCode1 &&
            this.order_productOption2 == optionCollect.optionCode2 &&
            this.order_productOption3 == optionCollect.optionCode3 &&
            this.order_instType == optionCollect.instType &&
            this.order_checkType == optionCollect.checkType
          ) {
            optionProdCode = optionCollect.prodCode;
            break;
          }
        }
      } else if (this.order_type == 'pay') {
        for (let optionCollect of this.prodOptionCollect) {
          if (
            this.order2_productOption1 == optionCollect.optionCode1 &&
            this.order2_productOption2 == optionCollect.optionCode2 &&
            this.order2_productOption3 == optionCollect.optionCode3 &&
            this.order2_instType == optionCollect.instType &&
            this.order2_checkType == optionCollect.checkType
          ) {
            optionProdCode = optionCollect.prodCode;
            break;
          }
        }
      }

      if (optionProdCode == '') {
        optionProdCode = this.productDetail.internalProdCode;
      }

      return optionProdCode;
    },
    basketClose() {
      this.messagePop2 = false;
      this.$emit('close');
    },
    getPrice() {
      let price = '0';

      if (this.productOptions.productOption1.length == 0) {
        this.order_productOption1 = 'FM060001';
        this.order2_productOption1 = 'FM060001';
      }
      if (this.productOptions.productOption2.length == 0) {
        this.order_productOption2 = 'FM060001';
        this.order2_productOption2 = 'FM060001';
      }
      if (this.productOptions.productOption3.length == 0) {
        this.order_productOption3 = 'FM060001';
        this.order2_productOption3 = 'FM060001';
      }
      if (this.productOptions.instType.length == 0) {
        this.order_instType = 'RNOR0001';
        this.order2_instType = 'RNOR0001';
      }
      if (this.productOptions.checkType.length == 0) {
        this.order_checkType = 'RREG0001';
        this.order2_checkType = 'RREG0001';
      }

      if (this.order_type == 'rental') {
        for (let optionCollect of this.prodOptionCollect) {
          if (
            this.order_rentalPeriod == optionCollect.rentalPeriod &&
            this.order_productOption1 == optionCollect.optionCode1 &&
            this.order_productOption2 == optionCollect.optionCode2 &&
            this.order_productOption3 == optionCollect.optionCode3 &&
            this.order_instType == optionCollect.instType
          ) {
            price = optionCollect.rentalAmount;
            break;
          }
        }

        if (price != '0') {
          this.show_rentalAmount = price;
        } else {
          this.show_rentalAmount = this.productDetail.rentalAmount;
        }
      } else if (this.order_type == 'pay') {
        for (let optionCollect of this.prodOptionCollect) {
          if (
            this.order2_productOption1 == optionCollect.optionCode1 &&
            this.order2_productOption2 == optionCollect.optionCode2 &&
            this.order2_productOption3 == optionCollect.optionCode3 &&
            this.order2_instType == optionCollect.instType &&
            this.order2_checkType == optionCollect.checkType
          ) {
            price = optionCollect.saleAmount;
            break;
          }
        }

        if (price != '0') {
          this.show_saleAmount = price;
        } else {
          if (this.order_type != 'pay' && this.productOptions.productOption1.length == 0) {
            this.show_saleAmount = this.productDetail.saleAmount;
          }
        }
      }
    },
    changed(saleAmount, internalProdCode) {
      this.show_saleAmount = saleAmount;
      this.internalProdCode = internalProdCode;
      this.getPrice();
    },
  },
};
</script>
